import styled from 'styled-components'

export const SpinnerWrapper = styled.div`
  font-size: 16px;
  padding: 16px;

  em {
    color: #999;
  }
`

export const AutocompleteDropdownResult = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  font-size: 16px;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  padding: 8px;
  width: 100%;
  text-transform: none;
  background-color: ${({ theme }) => theme?.['-ds-neutral-100']?.value};
  transition: background-color 0.3s;
  border-radius: 4px;

  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme?.['-ds-neutral-300']?.value};
    cursor: pointer;
  }
`

export const DropDownWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  color: ${({ theme }) => theme?.['-ds-neutral-600']?.value};
`

export const DropdownTitle = styled.p`
  font-weight: 400;
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-xs']?.['font-size']?.value};
  margin: 4px 0;
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  line-height: 1.2;
`
